import {
  EFTransactionIDToken,
  EverflowClientAffiliateIDCookie,
  EverflowClientAffiliateIDToken,
  EverflowClientCookie,
  EverflowClientOfferIDToken,
  EverflowClientSourceIDCookie,
  EverflowClientSubIDCookie
} from '@/enums/gtm'
import { getCookieDomain } from '@/utils/cookie'
import { serializeParameters, logError } from '@/utils/general'
import EverflowSDK from '@everflow/everflow-sdk'
import { useRoute } from 'nuxt/app'
import type { LocationQueryValue } from 'vue-router'

interface SubIds {
  adv_event_id?: LocationQueryValue | LocationQueryValue[]
  sub1?: LocationQueryValue | LocationQueryValue[]
  sub2?: LocationQueryValue | LocationQueryValue[]
  sub3?: LocationQueryValue | LocationQueryValue[]
  sub4?: LocationQueryValue | LocationQueryValue[]
  sub5?: LocationQueryValue | LocationQueryValue[]
}

export default defineNuxtPlugin(() => {
  const route = useRoute()

  const efcAffiliateIDToken = route.query[EverflowClientAffiliateIDToken] as string | undefined
  const efcOfferIDToken = route.query[EverflowClientOfferIDToken] as string | undefined
  const EFCTransactionIDToken = route.query[EFTransactionIDToken] as string | undefined

  const sourceId = route.query.source_id as string | undefined

  const subIds: SubIds = {
    adv_event_id: route.query.adv_event_id,
    sub1: route.query.sub1,
    sub2: route.query.sub2,
    sub3: route.query.sub3,
    sub4: route.query.sub4,
    sub5: route.query.sub5
  }

  const serializedParameters = serializeParameters(subIds)

  if (serializedParameters) {
    const efSubId = useCookie(EverflowClientSubIDCookie, {
      expires: new Date(Date.now() + 604800),
      path: '/',
      domain: getCookieDomain()
    })
    efSubId.value = serializeParameters(subIds)
  }

  if (sourceId) {
    const efSourceId = useCookie(EverflowClientSourceIDCookie, {
      expires: new Date(Date.now() + 604800),
      path: '/',
      domain: getCookieDomain()
    })
    efSourceId.value = sourceId
  }

  if (efcAffiliateIDToken) {
    const efAffiliateId = useCookie(EverflowClientAffiliateIDCookie, {
      expires: new Date(Date.now() + 604800),
      path: '/',
      domain: getCookieDomain()
    })
    efAffiliateId.value = efcAffiliateIDToken
  }

  if (efcAffiliateIDToken || EFCTransactionIDToken) {
    try {
      EverflowSDK.configure({
        tracking_domain: 'https://www.onthatass-deals.com'
      })

      EverflowSDK.click({
        offer_id: `${efcOfferIDToken}`,
        affiliate_id: `${efcAffiliateIDToken}`,
        sub1: EverflowSDK.urlParameter('sub1'),
        sub2: EverflowSDK.urlParameter('sub2'),
        sub3: EverflowSDK.urlParameter('sub3'),
        sub4: EverflowSDK.urlParameter('sub4'),
        sub5: EverflowSDK.urlParameter('sub5'),
        source_id: EverflowSDK.urlParameter('source_id'),
        transaction_id: EFCTransactionIDToken
      })
        .then((transactionID: string) => {
          const efClient = useCookie(EverflowClientCookie, {
            expires: new Date(Date.now() + 604800),
            path: '/',
            domain: getCookieDomain()
          })
          efClient.value = transactionID
        })
        .catch((error: Error) => {
          logError(error)
        })
    } catch (error) {
      logError(error as Error)
    }
  }
})
